import { firestore } from "@/firebase";
//import firebase from "firebase/app";
//import "firebase/auth";

const state = {
  kits: [],
  markers: []
};

const getters = {
  kits: state => state.kits,
  markers: state => state.markers
};

const mutations = {
  SET_KITS(state, kits) {
    state.kits = kits;
  },
  SET_MARKERS(state, markers) {
    // console.log(markers);
    state.markers = markers;
  }
};

let markersSubscription;
let kitsSubscription;

const actions = {
  kitsSubscribe({ commit }) {
    if (kitsSubscription) return;
    kitsSubscription = firestore
      .collection("kits")
      .orderBy("name", "asc")
      .onSnapshot(querySnapshot => {
        const all = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
        commit("SET_KITS", all);
      });
  },
  markersSubscribe({ commit }) {
    if (markersSubscription) return;
    markersSubscription = firestore
      .collection("benchmarks")
      .orderBy("name", "asc")
      .onSnapshot(querySnapshot => {
        const all = querySnapshot.docs.map(doc => {
          return { id: doc.id, ...doc.data() };
        });
        commit("SET_MARKERS", all);
      });
  },
  async getKitById(context, kitId) {
    const kit = await firestore
      .collection("kits")
      .doc(kitId)
      .get();
    return { id: kit.id, ...kit.data() };
  },
  kitsUnsubscribe() {
    kitsSubscription();
  },
  markersUnsubscribe() {
    markersSubscription();
  },
  async saveKit(context, payload) {
    // console.log(payload);
    await firestore
      .collection("kits")
      .doc(payload.id)
      .update({ ...payload, updated: Date.now() });
  },
  async getMarkers(context) {
    // REDUNDANT from testsStore
    return await firestore
      .collection("benchmarks")
      .get()
      .then(res => {
        let benchmarks = {};
        res.docs.forEach(doc => {
          benchmarks[doc.id] = doc.data();
        });
        return benchmarks;
      });
  },
  async addMarker(context, payload) {
    const marker = {
      id: payload.id,
      name: payload.id,
      description: "",
      type: "Type",
      unit: "Unit",
      range: [
        {
          title: "Minimum",
          value: 0
        }
      ]
    };
    await firestore
      .collection("benchmarks")
      .doc(payload.id)
      .set(marker);
    return marker;
  },
  async deleteMarker(context, payload) {
    await firestore
      .collection("benchmarks")
      .doc(payload.id)
      .delete();
  },
  async saveMarker(context, payload) {
    await firestore
      .collection("benchmarks")
      .doc(payload.id)
      .update({ ...payload, updated: Date.now() });
  },
  async addKit({ rootState, dispatch }, payload) {
    const id = firestore.collection("kits").doc().id;
    await firestore
      .collection("kits")
      .doc(id)
      .set({
        name: payload.kitName,
        id,
        cost: 0,
        description: "",
        markers: [],
        created: Date.now(),
        updated: Date.now()
      });
    return id;
  },
  async deleteKit({ dispatch }, payload) {
    await firestore
      .collection("kits")
      .doc(payload.id)
      .delete();
    // DELETE TESTS
    dispatch(
      "addToast",
      {
        message: "Deleted kit!",
        type: "pending"
      },
      { root: true }
    );
  }
  /*,
  async add({ rootState, dispatch }, payload) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .add({ ...payload, created: Date.now(), updated: Date.now() });
    dispatch(
      "addToast",
      {
        message: "Added client!",
        type: "good"
      },
      { root: true }
    );
  },
  async delete({ rootState, dispatch }, clientId) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(clientId)
      .delete();
    // DELETE TESTS
    dispatch(
      "addToast",
      {
        message: "Deleted client!",
        type: "pending"
      },
      { root: true }
    );
  },
  async get({ rootState }, clientId) {
    return await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(clientId)
      .get()
      .then(doc => {
        return { id: clientId, ...doc.data() };
      });
  },

  async updated({ rootState }, payload) {
    await firestore
      .collection("users")
      .doc(rootState.UserStore.user.uid)
      .collection("clients")
      .doc(payload.id)
      .update({ updated: Date.now() });
  }*/
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
